import {
  ADD_USER_FAILURE,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
} from "./UserTypes";

const initialState = {
  userAdd: null,
  loading: false,
  success: false,
  error: null,
  message: "",
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_USER_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case ADD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        userAdd: action.payload,
        message: "user Added successfully",
      };
    case ADD_USER_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case "RESET_USER_STATE":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default userReducer;
